import React from "react";
import NumericInput from "./NumericInput";

class NumericEditor extends React.Component {
    constructor(props){
        super(props);
        this.value = isNaN(parseInt(props.value)) ? "" :  props.value;
        this.inputRef = React.createRef();
    }

    componentDidUpdate(prevProps){
        if(this.props.column && this.props.column.colDef.field != prevProps.column.colDef.field){
            this.value = isNaN(parseInt(this.props.value)) ? "" : this.props.value;
            this.forceUpdate();
            this.focusOnInput();
        }

    }


    getValue = () => {
        if(this.value === ""){
            return ""
        }
        return Number(this.value);
    }

    isPopup = () => {
        return false;
    }

    afterGuiAttached = () => {
        this.focusOnInput();
    }

    focusOnInput = () => {
        if(this.inputRef && this.inputRef.current){
            this.inputRef.current.focus();
        }
    }

    handleChange = (event) => {
        this.value = event.target.value;
        this.props.onChange?.(event);
        this.forceUpdate();
    }

    render(){
        return (
            <NumericInput
                onChange={this.handleChange}
                value={this.value}
                inputRef={this.inputRef}
             >
            </NumericInput>
        )
    }
}
export default NumericEditor;